/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

//Description tabs on Product page

document.body.addEventListener('click', function (event) {
  if (event.target.hasAttribute('data-tab-btn')) {
    let currentBtn = event.target
    let tabName = currentBtn.getAttribute('data-tab-name')
    let tabBtns = document.querySelectorAll('[data-tab-btn]')
    let tabContentContainers = document.querySelectorAll('[data-tab-body]')
    let activeContentContainer = document.querySelector(`[data-tab-body][data-tab-name="${tabName}"]`)

    tabBtns.forEach(function (item) {
      item.classList.remove('active')
    })
    tabContentContainers.forEach(function (item) {
      item.classList.remove('active')
    })

    activeContentContainer.classList.add('active')
    currentBtn.classList.add('active')
  }
  // for issue with tab_template content 
  // if (event.target.hasAttribute('data-tab_templates')) {
  //   console.log('tab_templates');
  //   document.querySelector('.tab_template').classList.remove('hidden');
  // } else {
  //   document.querySelector('.tab_template').classList.add('hidden');
  // }
})

/*change arrows on the product gallery */
  url = window.location.href;
    if( url.match(/products/) ) {
      document.querySelector('.previous').innerHTML = document.querySelector('.btn_up').innerHTML;
      document.querySelector('.next').innerHTML = document.querySelector('.btn_down').innerHTML;
    } 
/* set top height for next btn */
window.addEventListener('resize', () => {
  try {
    if (window.matchMedia("(min-width: 999px)").matches) {
      const thumbElement = document.querySelector('.gallery_thumbnails');
      const nextButton = document.querySelector('.custom_gallery > .flickity-prev-next-button.next');
      
      if (thumbElement && nextButton) {
        const thumb = thumbElement.clientHeight;
        let thumb_height = `${thumb}px`;
        nextButton.style.top = thumb_height;
      } else {
        console.error('One or more elements not found.');
      }
    } else {
      const nextButton = document.querySelector('.custom_gallery > .flickity-prev-next-button.next');
      
      if (nextButton) {
        nextButton.style.top = 'calc(50% - 25px)';
      } else {
        console.error('Next button element not found.');
      }
    }
  } catch (error) {
    console.error('An error occurred:', error);
  }
});

// show tooltip for custom products (if product tags contains 'min_order_qty_10')
  const tool_qty = document.querySelector('.qty_tooltip');
  function show_qty_tooltip() {
    setTimeout(() => { tool_qty.classList.remove('hidden'); }, 100)
    setTimeout(() => { tool_qty.classList.add('hidden'); }, 2000)
  }

  const tooltip_qty_mob = document.querySelector('.qty_tooltip_mob');
  function show_tooltip_mob() {
    setTimeout(() => { tooltip_qty_mob.classList.remove('hidden'); }, 100)
    setTimeout(() => { tooltip_qty_mob.classList.add('hidden'); }, 2000)
  }
  
